const MOBILE_MEDIA = '(max-width: 1023px)';

export function shouldRunScrollAnimations(): boolean {
  if (import.meta.server) {
    return true;
  }
  return !window.matchMedia(MOBILE_MEDIA).matches;
}
